import { createReducer, createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';

type Value = string | boolean | null;

enum Preference {
    PREFERENCE_TERMINAL_ID = 'terminalId',
    PREFERENCE_KEYCUTTER_ID = 'keyCutterId',
    PREFERENCE_NOTES_EXPANDED = 'notesExpanded',
    PREFERENCE_BOOKING_ENGINE_ID = 'bookingEngineId',
}

const INITIAL_STATE = {
    [Preference.PREFERENCE_TERMINAL_ID]: null,
    [Preference.PREFERENCE_KEYCUTTER_ID]: null,
    [Preference.PREFERENCE_NOTES_EXPANDED]: false,
    [Preference.PREFERENCE_BOOKING_ENGINE_ID]: null,
};

export default ({ prefix, moduleSelector }: $TSFixMe) => {
    const SET_PREFERENCE = prefix('SET_PREFERENCE');

    const reducer = createReducer(INITIAL_STATE, {
        [SET_PREFERENCE]: (state: ApplicationState, { name, value }: { name: string; value: Value }) => ({
            ...state,
            [name]: value,
        }),
    });
    const setPreference = (name: Preference, value: Value) => createAction(SET_PREFERENCE, { name, value });
    const getPreference = (name: Preference) => (state: ApplicationState) =>
        moduleSelector(state)[name] || INITIAL_STATE[name];

    const setPreferredTerminalId = (id: string | null) => setPreference(Preference.PREFERENCE_TERMINAL_ID, id);
    const getPreferredTerminalId = getPreference(Preference.PREFERENCE_TERMINAL_ID);

    const setPreferredKeyCutterId = (id: string | null) => setPreference(Preference.PREFERENCE_KEYCUTTER_ID, id);
    const getPreferredKeyCutterId = getPreference(Preference.PREFERENCE_KEYCUTTER_ID);

    const setPreferredNotesExpanded = (expanded: boolean) =>
        setPreference(Preference.PREFERENCE_NOTES_EXPANDED, expanded);
    const getPreferredNotesExpanded = getPreference(Preference.PREFERENCE_NOTES_EXPANDED);

    const setPreferredBookingEngineId = (id: string) => setPreference(Preference.PREFERENCE_BOOKING_ENGINE_ID, id);
    const getPreferredBookingEngineId = getPreference(Preference.PREFERENCE_BOOKING_ENGINE_ID);

    return {
        actions: {
            setPreferredTerminalId,
            setPreferredKeyCutterId,
            setPreferredNotesExpanded,
            setPreferredBookingEngineId,
        },
        reducer,
        selectors: {
            getPreferredTerminalId,
            getPreferredKeyCutterId,
            getPreferredNotesExpanded,
            getPreferredBookingEngineId,
        },
    };
};
